<template>
  <div>
    <b-input
      :type="type"
      v-model="displayValue"
      @blur="isInputActive = false"
      class="inputCurrency"
      :class="{
        inputCurrencySaisie: isInputActive,
        inputCurrencyBackgroundGrid3: bg3
      }"
      @focus="isInputActive = true" :placeholder="placeholder" :disabled="disabled"/>
  </div>
</template>
<script>
export default {
  name: 'input-currency',
  props: ['value', 'placeholder', 'disabled', 'bg3'],
  data() {
    return {
      isInputActive: false,
      type: 'search',
    };
  },
  computed: {
    displayValue: {
      get() {
        if (!this.value && this.value !== 0) {
          return null;
        }
        if (this.isInputActive) {
          return this.value.toString();
        }
        return `${this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1 ').replace('.', ',')} €`;
      },
      set(modifiedValue) {
        if (!modifiedValue) {
          this.$emit('input', null);
          return;
        }
        const value = modifiedValue.replace(',', '.').replace(/[^\d.]/g, '');
        let newValue = parseFloat(value);
        if (isNaN(newValue)) {
          newValue = 0;
        }
        this.$emit('input', newValue);
      },
    },
  },
  beforeMount() {
    if (this.disabled) {
      this.type = 'text';
    }
  },
};
</script>
<style lang="scss">
.inputCurrency input{
  text-align: right;
}

.inputCurrencySaisie input{
  text-align: right;
}

.inputCurrencyBackgroundGrid3{
  input.input[disabled]{
    background-color: #E1E5EC !important;
  }
}

/* webkit solution */
::-webkit-input-placeholder { text-align:left; }
/* mozilla solution */
input[type="text"]::-moz-placeholder { text-align:left; }
input[type="text"]:-moz-placeholder { text-align:left; }
</style>
